// v16
// Path: frontend/src/components/SyncHub/StandardMappingsModal.jsx
// Inputs: token, onClose, onSaved
// Outputs: Full-screen modal housing the FieldMappingDesigner in Standard Mode
// Summary: Modal container providing backdrop light-dismiss, keyboard accessibility, and hosting the 2-level nested accordion Standard Field Mapping Designer.

import React, { useEffect } from 'react';
import { FieldMappingDesigner } from './FieldMappingDesigner';

export const StandardMappingsModal = ({ token, onClose, onSaved }) => {
    // Backdrop click dismiss
    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget && onClose) {
            onClose();
        }
    };

    // Keyboard Light Dismiss (Escape)
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                e.stopPropagation();
                if (onClose) onClose();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [onClose]);

    return (
        <div
            onClick={handleBackdropClick}
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4 sm:p-6 animate-fade-in"
            role="dialog"
            aria-modal="true"
            aria-label="Standard Field Mappings Designer"
        >
            <div className="bg-slate-900 border border-slate-700 rounded-2xl w-full max-w-7xl shadow-2xl flex flex-col h-[94vh] overflow-hidden">
                <FieldMappingDesigner
                    mode="standard"
                    token={token}
                    onClose={onClose}
                    onSaved={onSaved}
                />
            </div>
        </div>
    );
};

export default StandardMappingsModal;
